import VueI18n from 'vue-i18n';

const messages = {
    en: {
        MENU_CLOSE: 'Close',
        MENU_BACK: 'Back',

        RENDERER_BACK: 'Back',
        RENDERER_NEXT: 'Next',

        PRICE_EACH: 'each',

        ACTION_CANCEL: 'Cancel',
        ACTION_DONE: 'Review & Buy',
        ACTION_NEXT: 'Next',
        ACTION_CONTINUE: 'Continue',
        ACTION_SAVE: 'Save',
        ACTION_CLEAR: 'Clear',
        // ACTION_UPDATE: 'Update',
        ACTION_UPDATE: 'Add to cart',
        ACTION_CONFIRM: 'Confirm',

        MENU_PRODUCT_INFO: 'Product Info & Pricing',
        MENU_SIDE: 'Design On',
        MENU_IMAGES: 'Graphic',
        MENU_COLORS: 'Colors',
        MENU_TEXT: 'Text',
        MENU_MONOGRAM: 'Monogram',
        MENU_GROUP: 'Group Personalization',
        MENU_HELP: 'Help',

        PRODUCT_INFO_DESCRIPTION: 'Product Info & Pricing',
        PRODUCT_INFO_FEATURES: 'Features',
        PRODUCT_INFO_PRICING: 'Bulk Pricing',
        PRODUCT_INFO_PRICING_COPY: 'Lower your unit price when you order in bulk.',
        PRODUCT_INFO_PRICING_COPY_DETAILS: '{units} units: Save {save}/item',

        POPUP_CLOSE: 'Close',

        POPUP_LEAVING_HEADER: 'Are you sure you want to exit?',
        POPUP_LEAVING_BODY: 'Changes you made may not be saved.',
        POPUP_LEAVING_OK: 'Yes, exit customizer',
        POPUP_LEAVING_CANCEL: 'No, go back',
        POPUP_LEAVING_SAVE: 'Save My Design',

        COLORS_PRINTING: 'Printing Type',
        COLORS_ARE_YOU_SURE_ETCHING: 'Are you sure you want to switch to Laser Etching?',
        COLORS_ARE_YOU_SURE_FULL_COLOR: 'Are you sure you want to switch to Full Color Digital?',
        COLORS_CUSTOMIZATIONS_WILL_BE_LOST: 'Previous customizations will be lost if you proceed.',
        COLORS_CONFIRM_ETCHING: 'Yes, switch to Laser Etching',
        COLORS_CONFIRM_FULL_COLOR: 'Yes, switch to Full Color Digital',
        COLORS_STAY_ETCHING: 'No, stay on Laser Etching',
        COLORS_STAY_FULL_COLOR: 'No, stay on Full Color Digital',

        PRINTING_ETCHING: 'Laser Etching',
        PRINTING_PRINTING: 'Full Color Digital',

        DESIGN_ON: 'Apply design to',
        DESIGN_OFF: 'Preview',
        DESIGN_ON_SMALL: 'Apply to',

        DESIGN_SIDE: 'Design On',
        DESIGN_SIDE_FRONT_DESCRIPTION: 'Front Side',
        DESIGN_SIDE_BACK_DESCRIPTION: 'Back Side',
        DESIGN_SIDE_FRONTBACK_DESCRIPTION: 'Front & Back Sides',
        DESIGN_SIDE_BOTH_DESCRIPTION: 'Same Design',
        DESIGN_SIDE_FRONT: 'Front',
        DESIGN_SIDE_BACK: 'Back',
        DESIGN_SIDE_FRONTBACK: 'Front & Back',
        DESIGN_SIDE_BOTH: 'Same design on Front & Back',

        IMAGE_ADD: 'Add Image',
        IMAGE_UPLOAD_IMAGE: 'Upload',
        IMAGE_UPLOAD_GALLERY: 'Gallery',
        IMAGE_UPLOAD_ETCHING: 'Upload a transparent .PNG, .TIFF, .SVG, .AI, or .PDF file with the image in all black for the best quality laser etching.',
        IMAGE_UPLOAD_PRINTING: 'Upload a .PNG, .JPG, .TIFF, .SVG, .AI, or .PDF file.',
        IMAGE_UPLOAD_DROP: 'Drag and drop your file here',
        IMAGE_UPLOAD_OR: 'or',
        IMAGE_UPLOAD_UPLOAD_IMAGE: 'Upload Image',
        IMAGE_UPLOAD_BAD_TYPE_PRINTING: 'This file type is not supported.',
        IMAGE_UPLOAD_BAD_TYPE_PRINTING_COPY: 'Please use one of the following file types; png, jpg, tiff, ai, pdf, svg.',
        IMAGE_UPLOAD_BAD_TYPE_ETCHING: 'This file type is not supported.',
        IMAGE_UPLOAD_BAD_TYPE_ETCHING_COPY: 'Please use one of the following file types; png, tiff, ai, pdf, svg.',
        IMAGE_UPLOAD_BAD_SIZE: 'The image you attempted to upload is too large.',
        IMAGE_UPLOAD_BAD_SIZE_COPY: 'Please choose an image that is less than 6000x6000 in resolution.',
        IMAGE_UPLOAD_BAD_OUTLINES: 'Convert all fonts to outlines.',
        IMAGE_UPLOAD_BAD_OUTLINES_COPY: 'Please convert all type to outlines to ensure that the font’s appearance is preserved.',

        IMAGE_UPLOAD_JPEG: 'Heads up!',
        // eslint-disable-next-line max-len
        IMAGE_UPLOAD_JPEG_COPY: 'You uploaded a .jpg image. If it contains a white background and you want it to be removed, upload a .png file with a transparent background instead.',

        IMAGE_GALLERY_SELECT: 'Select image',

        IMAGE_EDIT: 'Edit Image',

        IMAGE_EDIT_FILE: 'File',
        IMAGE_EDIT_GRAPHIC: 'Graphic',
        IMAGE_EDIT_CHANGE: 'Change Image',
        IMAGE_EDIT_ALIGNMENT: 'Alignment',
        IMAGE_EDIT_LAYERING: 'Layering',
        IMAGE_EDIT_COLOR: 'Color',
        IMAGE_EDIT_COLOR_CHANGE: 'Image Color',

        IMAGE_EDIT_REMOVE: 'Remove',
        IMAGE_EDIT_EDIT: 'Edit',
        IMAGE_EDIT_LAYER_UP: 'Move Layer Up',
        IMAGE_EDIT_LAYER_DOWN: 'Move Layer Down',

        IMAGE_EDIT_ALIGN_LEFT: 'Left',
        IMAGE_EDIT_ALIGN_CENTER: 'Center',
        IMAGE_EDIT_ALIGN_RIGHT: 'Right',

        IMAGE_EDIT_ALIGN_TOP: 'Top',
        IMAGE_EDIT_ALIGN_VCENTER: 'Center',
        IMAGE_EDIT_ALIGN_BOTTOM: 'Bottom',

        IMAGE_UPLOAD_SMALL_GRAPHIC_GALLERY: 'Graphic Gallery',
        IMAGE_UPLOAD_SMALL_UPLOAD: 'Upload',

        IMAGE_IMAGES: 'Graphic',

        TEXT_ADD: 'Add Text',

        TEXT_EDIT: 'Edit Text',

        TEXT_TEXTS: 'Text',
        TEXT_ADD_OR_EDIT: 'Add or Edit Text',

        TEXT_EDIT_REMOVE: 'Remove',
        TEXT_EDIT_EDIT: 'Edit',
        TEXT_EDIT_CHANGE: 'Text',
        TEXT_EDIT_FONT: 'Font',
        TEXT_EDIT_COLOR: 'Color',

        DRAG_MOVE: 'Drag to move',
        DRAG_SCALE_ROTATE: 'Drag to resize and rotate',
        DRAG_ROTATE: 'Drag to rotate',
        DRAG_SCALE: 'Drag to resize',

        DRAG_MIN_TEXT_SIZE: 'Minimum text size reached',
        DRAG_MIN_IMAGE_SIZE: 'Minimum image size reached',

        TEXT_EDIT_COLOR_CHANGE: 'Text Color',

        MONOGRAM_ADD: 'Add Monogram',
        MONOGRAM_CHOOSE_STYLE: 'Choose Style',

        MONOGRAM_EDIT: 'Edit Monogram',

        MONOGRAM_TEXTS: 'Monograms',

        MONOGRAM_EDIT_REMOVE: 'Remove',
        MONOGRAM_EDIT_EDIT: 'Edit',
        MONOGRAM_EDIT_CHANGE: 'Initials',
        MONOGRAM_EDIT_STYLE: 'Style',
        MONOGRAM_EDIT_COLOR: 'Color',
        MONOGRAM_EDIT_INITIALS: 'Initials',
        MONOGRAM_EDIT_INITIALS_PLACEHOLDER: 'Enter initials',

        MONOGRAM_EDIT_COLOR_CHANGE: 'Monogram Color',

        COLOR_MORE: 'Show all',

        QUANTITY_SELECTOR: 'Quantity — ',
        QUANTITY_SELECTOR_SHORT: 'Qty: ',

        QUANTITY_ITEM: 'item',
        QUANTITY_ITEMS: 'items',
        QUANTITY_WARNING: 'Chosen color only has {ats} {items} in stock',
        QUANTITY_WARNING_BODY: 'If you continue with the color selection, excess items will be removed from the order.',

        CANCEL_CONFIRMATION: 'Are you sure you want to cancel?',
        CANCEL_CONFIRMATION_BODY: 'Changes you made may not be saved.',
        CANCEL_CONFIRMATION_OK: 'Yes, cancel',
        CANCEL_CONFIRMATION_CANCEL: 'No, go back',

        REVIEW_ORDER: 'Review your order',
        REVIEW_TOTALS: 'Total cost',
        REVIEW_BOTTLES: 'Number of items',
        REVIEW_SAVE: 'Save',
        REVIEW_PROOF: 'Proof',
        REVIEW_SHARE: 'Share',
        REVIEW_EMAIL: 'Email',
        REVIEW_HELP: 'Help',

        ACTION_ADD_TO_CART: 'Add to cart',

        // eslint-disable-next-line
        REVIEW_COPY: 'Looking good? The design you see is what you\'ll see on your final product. If you see a blank rectangle, that\'s what will appear on your item. Review carefully!',
        REVIEW_DISCLAIMER: '* Disclaimer - Colors may vary slightly from on-screen appearance in printing.',

        MENU_CHOOSE_COLOR: 'Choose Color',
        MENU_CHOOSE_SIZE: 'Choose Size',

        TEXT_STYLES: 'Text Styles',
        EDIT_TEXT_STYLES: 'Text Styles',

        EDIT_TEXT_FONT: 'Font',
        EDIT_TEXT_FONT_SIZE: 'Text Size',

        GROUP_TITLE: 'Group Personalization',
        GROUP_GROUP: 'Group',
        GROUP_DESC: 'With Group Ordering, you can customize names and or numbers to individual items.',
        GROUP_CSV: 'Upload CSV File',
        GROUP_ENTER_CUSTOM: 'OR enter your custom text',
        GROUP_HOW_MANY_BOTTLES: 'How many items?',
        GROUP_HOW_MANY_BOTTLES_DESC: 'You’ll enter text for each below.',
        GROUP_HOW_MANY_LINES: 'How many lines of text?',
        GROUP_HOW_MANY_LINES_DESC: '{lines} lines max.',
        GROUP_ENTER_TEXT: 'Enter your custom text for each item',
        GROUP_BOTTLE_LABEL: 'Item {bottle}',
        GROUP_REMOVE: 'Remove',
        GROUP_ADD_BOTTLE: 'Add Item',

        BOTTLE: 'Item',
        BOTTLE_EMPTY: '<empty>',

        GROUP_IMPORT_WARNING: 'Some items were not imported',
        // eslint-disable-next-line max-len
        GROUP_IMPORT_WARNING_BODY: 'Provided CSV file contains more rows than quantity available for the currently selected product color. Please select a different color and try again.',

        GROUP_ARE_YOU_SURE_GROUP: 'Are you sure you want to switch to Group Personalization?',
        GROUP_ARE_YOU_SURE_INDIVIDUAL: 'Are you sure you want to switch to Standard Customization?',
        // eslint-disable-next-line max-len
        GROUP_SWITCH_TO_GROUP_DESCRIPTION: 'Group Personalization is intended for orders that will have different text on each item. If you are ordering multiple items with the same design/text, stay on Standard and change the quantity.<br/><br/>You will lose any Standard Customization details you have added.',
        GROUP_SWITCH_TO_INDIVIDUAL_DESCRIPTION: 'You will lose any Group Personalization details you have added.',
        GROUP_SWITCH_CONFIRM_GROUP: 'Yes, switch to group',
        GROUP_SWITCH_STAY_GROUP: 'No, stay on group',
        GROUP_SWITCH_CONFIRM_INDIVIDUAL: 'Yes, switch to standard',
        GROUP_SWITCH_STAY_INDIVIDUAL: 'No, stay on standard',

        GROUP_INDIVIDUAL: 'Standard Customization',
        GROUP_INFORMATION: 'Group Information',
        GROUP_CUSTOMIZATION: 'Group Customization',
        GROUP_ENTER_NAMES: 'Enter your group’s names (or Numbers, Titles, etc.)',
        GROUP_CHANGE_STYLES_AFTER: 'You’ll be able to stylize the text after you’re done filling in all the information.',
        GROUP_PERSONALIZED_TEXT_LINE: 'Personalized Text Line {line}',

        // eslint-disable-next-line
        GROUP_LEARN_HOW: 'You can upload a CSV file with up to 5 columns. Each column will represent a line of text on your item, and each row will represent the text for an individual item. For example, if you\'d like to create items for 16 people with their first and last name, you would create a csv document with 2 columns (for first and last name) and 16 rows (one for each of your items).',

        SELECTOR_INCREASE: 'Increase',
        SELECTOR_DECREASE: 'Decrease',

        GET_STARTED: 'GET STARTED',

        NO_PERSONALIZATIONS: 'You have not made any customizations to your item.',
        // eslint-disable-next-line max-len
        NO_PERSONALIZATIONS_BODY: 'Please customize your items before adding to your cart.',

        DESIGN_OUTSIDE_WARNING: 'Your designs are outside the printing area.',
        DESIGN_OUTSIDE_WARNING_SUBLINE: 'To ensure your full design is printed, please stay within the printing area.',

        TOS_HEADER: 'Things to know before you get started',
        TOS_WARNING: 'Due to the unique nature of customization, we ask that you please agree to the following before proceeding to checkout.',
        // eslint-disable-next-line max-len
        TOS_CHECKBOX: 'I agree to the official Purchasing Terms of pelicanhydration.com (Pelican Hydration requests that you review the full Purchasing Terms prior to agreeing. Certain key Terms are summarized below):',
        TOS_LINE1: 'All customized products are ineligible for return',
        // eslint-disable-next-line max-len
        TOS_LINE2: 'You acknowledge that you have the rights to, or rights to use, any images or artwork you’ve uploaded. You agree to be held legally responsible for any claims, including those brought against Pelican Hydration, alleging a violation of intellectual property rights in connection with a customization order.',
        TOS_LINE3: 'Pelican Hydration reserves the right, in their sole discretion, to decline to customize any product.',
        // eslint-disable-next-line max-len
        TOS_LINE4: 'I understand that variations will exist between the on-screen appearance of my design and the customized item. Colors are not guaranteed to match. To learn more about color and other design tips and tricks, refer to our <a target="_blank" href="https://pelicanhydration.com/pages/faq">FAQ</a>',
        TOS_LINE5: 'I understand that customized items may require up to 2 business weeks for processing prior to shipping.',

        MIRROR: 'Mirror',

        SAVING: 'Adding to cart...',
        SAVING_GROUP: 'Large group orders may take longer to process.',

        // eslint-disable-next-line max-len
        DESIGN_SUPPORTED_SIDE: 'Digital print bottles can support designs on the front, back, or both. Laser etch bottles can support designs on the front or back, but not both.',

        ALL_OUT_TITLE: 'Out of Stock',
        ALL_OUT_BODY: 'All colors of this product are currently out of stock. To proceed, please go back and select a different product.',

        NOGROUP_TITLE: 'Are you sure you want to continue with Group Personalization?',
        // eslint-disable-next-line max-len
        NOGROUP_BODY: 'Group Personalization is intended for orders that will have different text on each bottle, but you have not entered unique name details. If you are ordering multiple bottles with the same design/text, switch to the Standard Personalization and change the quantity.',
        NOGROUP_ACCEPT: 'Switch to standard',
        NOGROUP_CANCEL: 'Review Group Personalization',

        // eslint-disable-next-line max-len
        METHODS_SMALL: 'Digital print bottles can support designs on the front, back, or both. Laser etch bottles can support designs on the front or back, but not both.',

        // eslint-disable-next-line max-len
        LONGEST_NAME: '<p>Please enter the longest name first, as it sets the font size template for all bottles. Names on subsequent bottles will be adjusted to match this size.</p><p>Note: If the longest name is not entered first, the order of bottles will be automatically rearranged to ensure the first bottle displays the longest name.</p>',

        LONGEST_NAME_WARNING_TITLE: 'Review bottles',

        // eslint-disable-next-line max-len
        LONGEST_NAME_WARNING: 'We\'ve rearranged the bottle order based on name length to ensure optimal font size for all bottles. Please review and confirm the personalization font size and alignment.',

        V3_GROUP_HEADER: 'CHOOSE YOUR CUSTOMIZATION',
        V3_GROUP_INFO: 'With Group Personalization, you can customize the names and/or numbers on individual bottles with the same design.',
        V3_SINGLE_INFO: 'Applies the same design to all bottles.',
        V3_GET_STARTED: 'GET STARTED',
        V3_PRICE_EACH: 'Each',
        V3_ITEM_COLOR: 'ITEM COLOR',
        V3_PRINT_COLORS: 'FULL COLOR DIGITAL',
        V3_PRINT_COLORS_TIP: 'For use with stainless steel items. Upload a PNG, AI, or PDF file with transparent background only.',
        V3_ETCH_COLORS: 'LASER ETCHING',
        V3_ETCH_COLORS_TIP: 'For use with stainless steel items. Upload a PNG, AI, or PDF file with transparent background only.',
        V3_BACK: 'BACK',
        V3_NEXT: 'NEXT',
        V3_CLOSE: 'Close',
        V3_CHANGE: 'CHANGE',
        V3_DESIGN_FRONT: 'FRONT',
        V3_DESIGN_BACK: 'BACK',
        V3_DESIGN_BACK_TOP: 'BACK TOP',
        V3_DESIGN_FIRST: ' - OPTION 1 OF 2',
        V3_DESIGN_SECOND: ' - OPTION 2 OF 2',
        V3_HELP: 'Help',
        V3_SKIP: 'SKIP OPTION',
        V3_RETURN: 'Close',
        V3_GRAPHIC_GALLERY: 'GRAPHIC',
        V3_UPLOAD: 'UPLOAD',
        V3_ADD_TEXT: 'TEXT',
        V3_ADD_MONOGRAM: 'MONOGRAM',
        V3_CHOOSE_IMAGE: 'CHOOSE AN IMAGE',
        V3_GROUP_INDIVIDUAL: 'Single Item',
        V3_GROUP_TITLE: 'Group Personalization',

        V3_ALIGN_LEFT: 'Left',
        V3_ALIGN_HCENTER: 'Center Horizontally',
        V3_ALIGN_RIGHT: 'Right',

        V3_ALIGN_TOP: 'Top',
        V3_ALIGN_VCENTER: 'Center Vertically',
        V3_ALIGN_BOTTOM: 'Bottom',

        V3_GRAPHIC_GALLERY_LARGE: 'GRAPHIC GALLERY',

        V3_STEP_IMAGE_ALIGNMENT: 'IMAGE ALIGNMENT',
        V3_STEP_IMAGE_COLOR: 'IMAGE COLOR',
        V3_STEP_REVIEW: 'REVIEW',

        V3_UPDATE_CART: 'UPDATE CART',
        V3_ADD_TO_CART: 'ADD TO CART',

        V3_REVIEW_SAVE: 'SAVE',
        V3_REVIEW_PROOF: 'PROOF',
        V3_REVIEW_SHARE: 'SHARE',
        V3_REVIEW_HELP: 'HELP',

        V3_QTY: 'QUANTITY',
        V3_TOTAL: 'TOTAL',

        V3_CUSTOMIZE_TEXT: 'CUSTOMIZE YOUR TEXT',
        V3_CUSTOMIZE_MONOGRAM: 'CREATE YOUR MONOGRAM',
        V3_CUSTOMIZE_UPLOAD: 'UPLOAD YOUR OWN IMAGE',
        V3_CUSTOMIZE_GALLERY: 'GRAPHIC GALLERY',

        V3_EDIT_TEXT: 'ENTER TEXT',
        V3_EDIT_TEXT_PLACEHOLDER: 'Enter text',
        V3_EDIT_TEXT_COLOR: 'TEXT COLOR',
        V3_EDIT_TEXT_FONT: 'TEXT FONT',
        V3_EDIT_TEXT_ALIGNMENT: 'TEXT ALIGNMENT',

        V3_EDIT_IMAGE_ALIGNMENT: 'IMAGE ALIGNMENT',

        V3_CHANGE_DESIGN_CONFIRM: 'CHANGE DESIGN OPTION',
        V3_CHANGE_DESIGN_BODY: 'By changing design option all the customizations you have done will be lost.',

        V3_EDIT_MONOGRAM: 'ENTER INITIALS',
        V3_EDIT_MONOGRAM_COLOR: 'MONOGRAM COLOR',
        V3_EDIT_MONOGRAM_FONT: 'MONOGRAM STYLE',
        V3_EDIT_MONOGRAM_ALIGNMENT: 'MONOGRAM ALIGNMENT',
        V3_EDIT_MONOGRAM_PLACEHOLDER: 'Enter initials',

        V3_EDIT_MONOGRAM_HINT: 'Enter up to 3 initials; letters only',
        V3_EDIT_TEXT_HINT: 'Text does not wrap and will be on a single line.',
        V3_EDIT_TEXT_VALIDATION: 'Sorry, one or more of the words you have chosen cannot be used.',

        V3_EDIT_UPLOAD: 'UPLOAD YOUR IMAGE',
        V3_EDIT_UPLOAD_EMPTY: 'UPLOAD IMAGE',

        V3_IMAGE_UPLOAD_ETCHING: 'Upload a transparent .PNG, .TIFF, .SVG, .AI, or .PDF file with the image in all black for the best quality laser etching.',
        V3_IMAGE_UPLOAD_PRINTING: 'Upload a .PNG, .JPG, .TIFF, .SVG, .AI, or .PDF file.',

        V3_UPLOAD_ISSUE: 'CHECK YOUR IMAGES',

        V3_DESIGN_FIRST_OPTION: 'DESIGN OPTIONS',

        V3_CHANGE_PRINTING_TYPE: 'CHANGE PRINTING TYPE',
        V3_CHANGE_PRINTING_TYPE_BODY: 'By changing printing type all the customizations you\'ve done will be lost.',

        V3_CUSTOMIZATION_TYPE: 'CUSTOMIZATION TYPE',

        V3_RENDER_NEXT: 'Next angle',
        V3_RENDER_PREV: 'Previous angle',
        V3_VIEW_MORE: 'View more',

        V3_EDIT_IMAGE_COLOR: 'IMAGE COLOR',

        FREE: '$0',
    },
};

export default function translate(locale, overrides) {
    const translations = JSON.parse(JSON.stringify(messages));

    if (overrides) {
        Object.keys(translations).forEach((lang) => {
            if (overrides[lang]) {
                Object.assign(translations[lang], overrides[lang]);
            }
        });

        Object.keys(overrides).forEach((lang) => {
            if (overrides[lang]) {
                if (translations[lang] == null) {
                    translations[lang] = {};
                }
                Object.assign(translations[lang], overrides[lang]);
            }
        });
    }

    return new VueI18n({
        locale,
        fallbackLocale: 'en',
        messages: translations,
        silentFallbackWarn: true,
    });
}
